import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'register',
        component: () => import('../views/Register'),
    },
]

export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})
